/**
 * @generated SignedSource<<1a9c2770036e9d4a3e195f888c54c7cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FunnelBulkCreateTabContainer_Query$variables = {
  siteSlug: string;
};
export type FunnelBulkCreateTabContainer_QueryVariables = FunnelBulkCreateTabContainer_Query$variables;
export type FunnelBulkCreateTabContainer_Query$data = {
  readonly site: {
    readonly id: string;
  };
};
export type FunnelBulkCreateTabContainer_QueryResponse = FunnelBulkCreateTabContainer_Query$data;
export type FunnelBulkCreateTabContainer_Query = {
  variables: FunnelBulkCreateTabContainer_QueryVariables;
  response: FunnelBulkCreateTabContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "siteSlug"
      }
    ],
    "concreteType": "Site",
    "kind": "LinkedField",
    "name": "site",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelBulkCreateTabContainer_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FunnelBulkCreateTabContainer_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1ac01356c9fd6cb4c6797ee3ca0b60db",
    "id": null,
    "metadata": {},
    "name": "FunnelBulkCreateTabContainer_Query",
    "operationKind": "query",
    "text": "query FunnelBulkCreateTabContainer_Query(\n  $siteSlug: String!\n) {\n  site(slug: $siteSlug) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e672b23d77b7396122c638850bccbbfd";

export default node;
